import { Navigate } from 'react-router-dom';

export function FubContainersPage(): JSX.Element {
  return <Navigate replace to="/resources" />;
}
